import { ImageColorFinderFlight, VideoColorFinderFlight } from "@nova/protobuf"
import { isVideoFlight } from "../ColorFinderQueries"
import { fileManagementApi } from "features/data-management/files/fileManagementApi"
import { decompress } from "plugins/shared/compression"
import { localImageColorDataMap } from "plugins/ColorFinder/ImageColorFinder/ImageColorFinderSlice"
import { localVideoMap } from "plugins/shared/useUniversalControl"
import useSWR from "swr"

// Demo paths may be stored as full org paths ("public/org/.../flight/<id>/...") or
// already as flight-relative paths ("flight/<id>/..."). Normalize to the demo bucket key.
const toDemoKey = (path: string, isDemo: boolean) => {
    if (!isDemo) return path
    const idx = path.indexOf("flight/")
    return `public/sample-data/${idx >= 0 ? path.slice(idx) : path}`
}

const fetchAnomalyIndex = async (s3Key: string, isDemo: boolean) => {
    const index = await fileManagementApi
        .fetchFile(s3Key, { isDemo })
        .then((res) => res.arrayBuffer())
        .then((res) => decompress<Uint8Array>(res, "gzip"))
        .then((res) => new Uint8Array(res))

    return index
}

const getAnomalyIndex = async (flight: ImageColorFinderFlight | VideoColorFinderFlight) => {
    if (isVideoFlight(flight)) {
        const local = localVideoMap[flight.id]
        if (local?.anomalyIndex) return local.anomalyIndex

        if (!flight.job?.anomalyPath) return
        const isDemo = !!flight.demoId
        return await fetchAnomalyIndex(toDemoKey(flight.job.anomalyPath, isDemo), isDemo)
    } else {
        if (localImageColorDataMap[flight.id]?.anomalyIndex) {
            return localImageColorDataMap[flight.id].anomalyIndex
        }

        if (!flight.anomalyPath) return

        return await fetchAnomalyIndex(flight.anomalyPath, !!flight.demoId)
    }
}

const useAnomalyIndex = (flight: ImageColorFinderFlight | VideoColorFinderFlight) => {
    const { data, isLoading, error } = useSWR(
        ["anomaly", flight.id],
        async () => await getAnomalyIndex(flight)
    )

    if (error) {
        console.error(error)
    }

    return { data, isLoading }
}

export { useAnomalyIndex }
